import { useId } from 'react'
import { ALLOWED_IPS_HINT } from '../lib/ipacl'

/**
 * The optional per-gateway source-IP allowlist editor: one CIDR range per
 * line, client-side validated (see src/lib/ipacl.ts — the backend
 * revalidates). Empty means any source.
 */
export function AllowedIpsField({
  value,
  onChange,
  error,
}: {
  value: string
  onChange: (value: string) => void
  error: string | null
}) {
  const autoId = useId()
  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={autoId}
        className="text-[10px] font-semibold uppercase tracking-widest text-ostrel-ink-muted"
      >
        Allowed source IPs (optional)
      </label>
      <textarea
        id={autoId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
        spellCheck={false}
        placeholder={'203.0.112.0/22\n2001:db8::/64'}
        className="tnum rounded-sm border border-ostrel-line bg-ostrel-card px-3 py-2 font-mono text-xs text-ostrel-ink placeholder:text-ostrel-ink-muted focus:border-ostrel-gold focus:outline-none focus:ring-1 focus:ring-ostrel-gold"
      />
      {error ? (
        <p className="text-xs text-ostrel-danger">{error}</p>
      ) : (
        <p className="text-[11px] leading-relaxed text-ostrel-ink-muted">{ALLOWED_IPS_HINT}</p>
      )}
    </div>
  )
}
